import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import CircleButton from '../../buttons/circleButton'
import FavoriteIcon from '../../../../shared/components/icons/favorite'

import styles from './favoriteButton.module.css'

const FavoriteButton = ({
  href,
  onClick,
  isActive = false,
  className = ''
}) => {
  const classes = classnames(styles.link, {
    [styles.linkActive]: isActive,
    [className]: !!className
  })

  return (
    <CircleButton
      href={href}
      className={classes}
      onClick={onClick}
      title="Add to Favorites"
      rel="nofollow"
    >
      <FavoriteIcon width="20" height="16" className={styles.icon} />
    </CircleButton>
  )
}

FavoriteButton.propTypes = {
  href: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isActive: PropTypes.bool,
  className: PropTypes.string
}

export default FavoriteButton
